module.exports = __webpack_public_path__ + "img/eclipse.517bb523.svg";